const truncateText = (maxLength: number, text?: string) => {
  if (!text || text.length < maxLength) {
    return text
  }

  return text.substring(0, maxLength) + '...'
}

export default truncateText
